import { Link } from 'react-router-dom'

interface LogoProps {
  variant?: 'light' | 'dark' // light = for white backgrounds, dark = for dark backgrounds
  className?: string
}

export default function Logo({ variant = 'light', className = '' }: LogoProps) {
  const textColor = variant === 'light' ? 'text-slate-900' : 'text-white'

  return (
    <Link
      to="/"
      className={`flex items-center gap-3 no-underline ${className}`}
      aria-label="WealthSpace home"
    >
      {/* Mark: dino-egg from public/favicon.svg */}
      <img
        src="/favicon.svg"
        alt=""
        width={32}
        height={32}
        className="w-8 h-8 select-none"
        draggable={false}
      />

      {/* Wordmark: uppercase, tracked. Weight + size matched to header nav so it sits beside the menu, not above it. */}
      <span
        className={`font-sans font-medium uppercase text-[14px] leading-none tracking-[0.18em] ${textColor}`}
      >
        WealthSpace
      </span>
    </Link>
  )
}
